module.exports = __webpack_public_path__ + "3a60a9fd7ee794a890a1a273ca679a16.svg";